import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { fetchScenesIfOK, setCurrentScene, showCreateActivityModal, showCreateSkillModal, showCreateSkillGroupModal, setCurrentPage } from '../../actions';
import NavBar from './NavBar';

class NavBarContainer extends Component {
    componentDidMount() {
        this.props.fetchScenesIfOK();
    }

    render () {
        const { options, setCurrentScene, showCreateActivityModal, showCreateSkillModal, showCreateSkillGroupModal, setCurrentPage } = this.props;
        return (
            <NavBar options={options} setPage={setCurrentPage} setScene={setCurrentScene} showCreateActivityModal={showCreateActivityModal} showCreateSkillModal={showCreateSkillModal} showCreateSkillGroupModal={showCreateSkillGroupModal}/>
        );
    }
}

NavBarContainer.propTypes =  {
    fetchScenesIfOK:         PropTypes.func.isRequired,
    setCurrentScene:         PropTypes.func.isRequired,
    showCreateActivityModal: PropTypes.func.isRequired,
    showCreateSkillModal:    PropTypes.func.isRequired,
    showCreateSkillGroupModal: PropTypes.func.isRequired,
    options:                 PropTypes.array.isRequired,
    setCurrentPage: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    options: state.scene.all
});

const mapDispatchToProps = ({
    fetchScenesIfOK,
    setCurrentScene,
    showCreateActivityModal,
    showCreateSkillModal,
    showCreateSkillGroupModal,
    setCurrentPage
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NavBarContainer);



// WEBPACK FOOTER //
// ./src/components/navBar/NavBarContainer.js